'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleClosedWelcomeMessage = undefined;

var _PostMessageTypes = require('../../constants/PostMessageTypes');

var _createPostMessageAction = require('./createPostMessageAction');

var handleClosedWelcomeMessage = exports.handleClosedWelcomeMessage = function handleClosedWelcomeMessage() {
  return function (dispatch) {
    dispatch((0, _createPostMessageAction.createPostMessageAction)(_PostMessageTypes.CLOSED_WELCOME_MESSAGE)());
  };
};